import React from 'react';

import PlayerDevicesContext from '../player-devices-context';
import PlayerDevicesDialogEditScreenDevicesItem from './player-devices-dialog-edit-screen-devices-item';
import styles from './player-devices-dialog.module.scss';

export const PlayerDevicesDialogEditScreenDevices: React.FC = () => {
  const { devices, handleRemoveDevices } = React.useContext(PlayerDevicesContext);

  return (
    <div className={styles['player-devices-dialog-edit-screen__devices']}>
      {devices?.map((device, index) => (
        <PlayerDevicesDialogEditScreenDevicesItem
          key={index}
          device={device}
          onEnterPress={() => handleRemoveDevices([device.uid])}
          onClick={handleRemoveDevices}
        />
      ))}
    </div>
  );
};

export default PlayerDevicesDialogEditScreenDevices;
